import { useEffect, useState } from "react";
import Navbar from "../navbar/Navbar";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  VStack,
  HStack,
  Text,
  Heading,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Avatar,
  Tag,
  useToast,
  Spinner,
  Divider,
  Center,
} from "@chakra-ui/react";

export default function UserAppointments() {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    if (!user) return;
    axios
      .get(`https://happyu.onrender.com/user/${user.username}/appointments`)
      .then((res) => { 
        setAppointments(res.data);
        console.log(res.data); 
      })
      .catch(() =>
        toast({
          title: "Error fetching appointments",
          status: "error",
          duration: 3000,
          isClosable: true,
        })
      )
      .finally(() => setLoading(false));
  }, [user?.username, toast]);

  const updateStatus = async (id, status, counsellorId) => {
    try {
      await axios.post(`https://happyu.onrender.com/appointments/update/${id}`, {
        status,
      });

      setAppointments((prev) =>
        prev.map((a) => (a._id === id ? { ...a, status } : a))
      );

      toast({
        title:
          status === "accepted"
            ? "Appointment accepted"
            : status === "declined"
            ? "Appointment declined"
            : "Status updated",
        status:
          status === "accepted"
            ? "success"
            : status === "declined"
            ? "error"
            : "info",
        duration: 2000,
        isClosable: true,
      });
    } catch {
      toast({
        title: "Error updating status",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  if (loading)
    return (
      <Center h="100vh">
        <VStack>
          <Spinner size="xl" color="blue.500" />
          <Text mt={2}>Loading appointments...</Text>
        </VStack>
      </Center>
    );

  return (
    <>
      
      <Box bg="gray.50" minH="100vh" p={6} mt={16}>
        <VStack spacing={8} align="stretch" maxW="800px" mx="auto" mt={8}>
          <Heading textAlign="center" color="blue.700">
            Your Appointments
          </Heading>
          <Text textAlign="center" fontSize="lg" color="gray.600">
            View and manage your appointments
          </Text>

          {appointments.length === 0 ? (
            <Center>
              <Text fontSize="md" color="gray.500">
                No appointments yet.
              </Text>
            </Center>
          ) : (
            appointments.map((a) => {
              const roomId = [user._id, a.counsellorId].join("-");
              return (
                <Card
                  key={a._id}
                  bg="white"
                  shadow="md"
                  borderRadius="xl"
                  _hover={{ shadow: "lg", transform: "scale(1.01)" }}
                  transition="0.2s"
                >
                  <CardHeader>
                    <HStack justify="space-between">
                      <HStack spacing={3}>
                        <Avatar name={a.counsellorName} />
                        <Box>
                          <Text fontWeight="bold" fontSize="lg">
                            {a.counsellorName}
                          </Text>
                          <Text fontSize="sm" color="gray.500">
                            {a.date} — {a.time}
                          </Text>
                        </Box>
                      </HStack>
                      <Tag
                        size="md"
                        colorScheme={
                          a.status === "accepted"
                            ? "green"
                            : a.status === "declined"
                            ? "red"
                            : "yellow"
                        }
                      >
                        {a.status.toUpperCase()}
                      </Tag>
                    </HStack>
                  </CardHeader>

                  <Divider />

                  <CardBody>
                    <Text color="gray.600" fontSize="sm">
                      Appointment ID: {a._id}
                    </Text>
                  </CardBody>

                  <CardFooter justify="flex-end">
                    {a.status === "accepted" ? (
                      <HStack spacing={3}>
                        <Button
                          colorScheme="blue"
                          onClick={() => navigate(`/chat/${roomId}`)}
                        >
                          Chat
                        </Button>
                        <Button
                          colorScheme="purple"
                          onClick={() => navigate(`/video/${roomId}`)}
                        >
                          Video Call
                        </Button>
                      </HStack>
                    ) : a.status === "declined" ? (
                      <Text color="red.500" fontWeight="semibold">
                        Appointment declined
                      </Text>
                    ) : (
                      <HStack spacing={3}>
                        <Button
                          colorScheme="green"
                          onClick={() =>
                            updateStatus(a._id, "accepted", a.counsellorId)
                          }
                        >
                          Accept
                        </Button>
                        <Button
                          colorScheme="red"
                          onClick={() =>
                            updateStatus(a._id, "declined", a.counsellorId)
                          }
                        >
                          Decline
                        </Button>
                      </HStack>
                    )}
                  </CardFooter>
                </Card>
              );
            })
          )}
        </VStack>
      </Box>
    </>
  );
}
